module.exports = __webpack_public_path__ + "img/amy-wepublic.19d692c6.png";